//#region IMPORT
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import M_RNM_BASIC_03 from './M_RNM_BASIC_03';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import { useSave1 } from './M_RNM_BASIC_03_Query';
import { useSave } from '../../../Hooks/useSave';
import { M_RNM_BASIC_03_Schema } from './M_RNM_BASIC_03_Schema';
import { BackInfoActions } from '../../../Reducer/BackInfoReducer';
import useFileUpload from '../../../Hooks/useFileUpload';
import useFcmHandler from '../../../Hooks/useFcmHandler';
import { useNavigate, useLocation } from 'react-router-dom';
//#endregion

function M_RNM_BASIC_03F() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const detailItem = location.state?.detailItem ?? null;
  //#region 커스텀훅
  const workInfoUpload = useFileUpload({
    oldFilePathField: 'imageFilePath',
    newFileNameField: 'saveName',
    getTargetPath: () => `AccidentStatus/${userInfo.custCd}/ACS_BASIC_02/Post`,
    multiple: true,
    fileResultType: 'array',
  });
  const sendFcm = useFcmHandler();
  //#endregion

  useEffect(() => {
    Init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Init = async () => {
    try {
      dispatch(NavBarInfoActions.setType('titleBar'));
      dispatch(NavBarInfoActions.setTitleName('조치 등록'));
    } catch (e) {
      console.error('Init Error:', e);
    }
  };

  const { runAsync: Save1Async } = useSave1();

  const { run: Save1 } = useSave({
    menuId: 'M_RNM_BASIC_03',
    schema: M_RNM_BASIC_03_Schema,
    saveData: (param) => param,
    fileSave: async () => {
      // 서버 저장 시 Images 배열이 덮어쓰기 되므로,
      // 기존(PRE 포함) 이미지 + 신규 업로드(POST) 이미지를 합쳐서 전달해야 개선전 사진이 유지됨
      const existingImages = (detailItem?.images ?? []).map((i) => ({
        ImgType: i?.imgType ?? '',
        ImageFileName: i?.imageFileName ?? '',
        ImageFilePath: i?.imageFilePath ?? '',
        ImageSaveName: i?.imageSaveName ?? '',
      }));

      const moved = await workInfoUpload.SaveLogicFile();
      const movedImages = (moved || []).map((r) => ({
        ImgType: 'POST',
        ImageFileName: r.fileName ?? '',
        ImageFilePath: r.filePath ?? '',
        ImageSaveName: r.saveName ?? '',
      }));

      // 중복 제거 (saveName + filePath 기준)
      const deduped = [];
      const seen = new Set();
      for (const img of [...existingImages, ...movedImages]) {
        const key = `${img.ImageSaveName ?? ''}__${img.ImageFilePath ?? ''}__${img.ImgType ?? ''}`;
        if (seen.has(key)) continue;
        seen.add(key);
        deduped.push(img);
      }

      return { images: deduped };
    },
    requestSave: (rows) => Save1Async(rows),
    onSuccess: async () => {
      //fcm 알림요청
      await sendFcm({
        targetUserId: detailItem.discovererId,
        body: '조치가 완료되었습니다. 확인해주세요.',
        codeGroup: 'AL_009_003',
        title: '안전신문고',
        route: '/M_RNM',
      });

      workInfoUpload.clearFiles();
      dispatch(BackInfoActions.pop());
      navigate('/M_RNM');
    },
  });

  return (
    <div className="wrap">
      <M_RNM_BASIC_03
        detailItem={detailItem}
        workInfoUpload={workInfoUpload}
        Save1={Save1}
      />
    </div>
  );
}

export default M_RNM_BASIC_03F;
